// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__3LURV","imgSrc":"styles_imgSrc__3fknE"};